<button
	type="button"
	[class]="btnClass"
	[class.disabled]="disabled"
	(click)="onClick()"
>
	<ng-content />
</button>
